import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableHaberFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    (salida) => {
      setFieldValue('cuentaContableHaber', salida.value)
      setFieldValue('cuentaContableHaberInfo', salida.label)
      KeyEventUtil.leaveOnKeyEvent('input-porcentajeParticipacion')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableHaber', '')
    setFieldValue('cuentaContableHaberInfo', '')
    KeyEventUtil.leaveOnKeyEvent('select-cuentaContableHaber')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CC HABER' htmlFor='select-cuentaContableHaber'  md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableHaber' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable
            id='select-cuentaContableHaber'
            onlyAnalitica
            onChange={onChange}
          />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableHaberFormGroup)
